import { selectProductId } from "../../workers-site/renderer/engine-functions";

window.selectProductId = selectProductId;

window._sqzl = window._sqzl || [];
window.sqzlPushWrapper = function (obj) {
    const url = new URL(window.location.href);
    const hostname = url.hostname;
    if (obj.products && Array.isArray(obj.products)) {
        obj.products = obj.products.map(p => {
            return {
                ...p,
                'language': hostname.endsWith('volero.de') ? 'de-DE' : 'nl-NL'
            };
        });
    }
    window._sqzl.push({
        ...obj,
        'language': hostname.endsWith('volero.de') ? 'de-DE' : 'nl-NL'
    });
}